module.exports = "<html>\r\n<router-outlet></router-outlet>\r\n\r\n</html>"